import { render, staticRenderFns } from "./occupation-step.vue?vue&type=template&id=23c578c2"
import script from "./occupation-step.vue?vue&type=script&lang=js"
export * from "./occupation-step.vue?vue&type=script&lang=js"
import style0 from "./occupation-step.vue?vue&type=style&index=0&id=23c578c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports